<div *ngIf='contentInfo' class='EditContent'>
  <div class='EditContent-header'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/campaigns']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'
        >Campaigns</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <a
          [queryParams]='{ index }'
          [routerLink]="['/campaigns', cid, 'preview-content']"
          class='Breadcrumbs-item first'
        >{{ contentInfo.content_template }}</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>{{ contentInfo.content_name }}</span>
      </div>
    </div>
  </div>
  <div class='EditContent-body mt-3 mt-sm-5 p-0 p-sm-5'>
    <div class='d-flex flex-row justify-content-between align-items-center'>
      <h2>Edit Content</h2>
      <b class='d-none d-sm-block'>Select to apply in all Templates</b>
      <b class='d-block d-sm-none'>Apply all</b>
    </div>
    <div class='EditContent-form mt-1 mt-sm-3 p-0 p-sm-5'>
      <form [formGroup]='formGroup'>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='col col-12 col-md-2 d-flex align-items-center'>
              <mat-label>Group Name:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-text-field
                [disabled]='true'
                [fieldBackgroundClass]="'white'"
                [value]='contentInfo.content_group'></app-text-field>
            </div>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='col col-12 col-md-2 d-flex align-items-center'>
              <mat-label>Content Name:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-text-field
                [disabled]='true'
                [fieldBackgroundClass]="'white'"
                [value]='contentInfo.content_name'></app-text-field>
            </div>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div
              class='EditContent-form-label col col-12 col-md-2 d-flex align-items-center'>
              <mat-label>Subject:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-text-field
                [fieldBackgroundClass]="'white'"
                formControlName='subject'></app-text-field>
            </div>
          </div>
          <div class='col col-1 align-content-center'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_subject'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='EditContent-form-label col col-12 col-md-2'>
              <mat-label>Greeting</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-select
                (selection)='onGreetingsSelection($event)'
                [colorWhite]='true'
                [defaultValue]='contentInfo.greeting'
                [items]='greetings.items'
                [label]='greetings.label'
              ></app-select>
              <br />
              <app-editor formControlName='greeting'></app-editor>
            </div>
          </div>
          <div class='col col-1 align-content-center'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_greeting'></mat-checkbox>
          </div>
        </div>
        <ng-container [ngSwitch]='index.toString()'>
          <ng-container *ngSwitchCase='0'>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Attention:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #attention formControlName='attention'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, attention)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(attention)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 01:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit01 formControlName='benefit_01'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit01)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit01)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 02:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit02 formControlName='benefit_02'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit02)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit02)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='1'>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Opening:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #opening formControlName='opening'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, opening)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(opening)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 02:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit02 formControlName='benefit_02'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit02)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit02)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Attention:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #attention formControlName='attention'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, attention)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(attention)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 01:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit01 formControlName='benefit_01'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit01)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit01)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='2'>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Opening:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #opening formControlName='opening'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, opening)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(opening)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 01:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit01 formControlName='benefit_01'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit01)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit01)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="contentInfo.content_template !== 'email_template4'"
              class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 02:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit02 formControlName='benefit_02'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit02)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit02)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_02'></mat-checkbox>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase='3'>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Opening:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #opening formControlName='opening'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, opening)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(opening)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_opening'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Benefit 01:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #benefit01 formControlName='benefit_01'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, benefit01)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(benefit01)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_benefit_01'></mat-checkbox>
              </div>
            </div>
            <div class='EditContent-form-row row'>
              <div class='col col-11'>
                <div class='col col-12 col-md-2'>
                  <mat-label>Attention:</mat-label>
                </div>
                <div class='EditContent-form-row-middle col col-12 col-md-9'>
                  <app-editor #attention formControlName='attention'></app-editor>
                  <div class='d-flex flex-row'>
                    <div *ngIf='variables.length > 0' class='flex-grow-0'>
                      <app-select
                        (selection)='onVariableSelect($event, attention)'
                        [items]='variables'
                        [label]="'Insert Variable'"></app-select>
                    </div>
                    <button
                      *ngIf='contentInfo?.campaign_recruit'
                      type='button'
                      class='btn btn-link p-0 ms-2'
                      (click)='insertRecruitLink(attention)'
                    >
                      Insert Recruit Link
                    </button>
                  </div>
                </div>
              </div>
              <div class='col col-1 align-content-center'>
                <mat-checkbox
                  class='EditContent-form-checkbox'
                  formControlName='apply_attention'></mat-checkbox>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='col col-12 col-md-2'>
              <mat-label>Closing:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-editor #closing formControlName='closing'></app-editor>
              <div class='d-flex flex-row'>
                <div *ngIf='variables.length > 0' class='flex-grow-0'>
                  <app-select
                    (selection)='onVariableSelect($event, closing)'
                    [items]='variables'
                    [label]="'Insert Variable'"></app-select>
                </div>
                <button
                  *ngIf='contentInfo?.campaign_recruit && (index === 0 || index === 1 || index === 2 || index === 3)'
                  type='button'
                  class='btn btn-link p-0 ms-2'
                  (click)='insertRecruitLink(closing)'
                >
                  Insert Recruit Link
                </button>
              </div>
            </div>
          </div>
          <div class='col col-1 align-content-center'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_closing'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='col col-12 col-md-2'>
              <mat-label>Signature:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <div *ngIf='(!signature.touched || signature.dirty) && !signature.value' class='alert alert-warning'>
                <p>There is no signature text added for that template. The system will append your default profile
                  signature
                  for that email.</p>
              </div>
              <app-editor formControlName='signature'></app-editor>
            </div>
          </div>
          <div class='col col-12 col-md-1'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_signature'></mat-checkbox>
          </div>
        </div>
        <div class='EditContent-form-row row'>
          <div class='col col-11'>
            <div class='col col-12 col-md-2'>
              <mat-label>Detailed Statement:</mat-label>
            </div>
            <div class='EditContent-form-row-middle col col-12 col-md-9'>
              <app-editor #details formControlName='details'></app-editor>
              <div class='d-flex flex-row'>
                <button
                  *ngIf='contentInfo?.campaign_recruit && (index === 0 || index === 1 || index === 2 || index === 3)'
                  type='button'
                  class='btn btn-link p-0 ms-2'
                  (click)='insertRecruitLink(details)'
                >
                  Insert Recruit Link
                </button>
              </div>
            </div>
          </div>
          <div class='col col-1 align-content-center'>
            <mat-checkbox
              class='EditContent-form-checkbox'
              formControlName='apply_details'></mat-checkbox>
          </div>
        </div>
      </form>
    </div>
    <div class='EditContent-footer d-flex justify-content-end mt-4'>
      <app-button
        [Click]='cancelButtonProperties.onClick'
        [color]='cancelButtonProperties.color'
        [size]='cancelButtonProperties.size'
        [text]='cancelButtonProperties.text'
        class='EditContent-footer-button'></app-button>
      <app-button
        [Click]='submitButtonProperties.onClick'
        [color]='submitButtonProperties.color'
        [observeApi]='true'
        [size]='submitButtonProperties.size'
        [text]='submitButtonProperties.text'
        class='EditContent-footer-button'></app-button>
    </div>
  </div>
</div>
